import { Button } from '@mui/material'
import { styled } from '@mui/material/styles'

export const HBButton = styled(Button)({
  width: '100%',
  background: '#AF231C',
  boxShadow: 'none',
  color: 'white',
  fontWeight: 600,
  fontSize: '1rem',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#c1544d',
  },
  '&:focus, &:focus-within': {
    outline: '1px solid #1270B8',
  },
})
